export default "__VITE_ASSET__BBAQwGEj__"